import moment from "moment";
import React, { useState } from "react";
import FilterToolbar from "../inputs/FilterToolbar";
import {
  Alert,
  Badge,
  Button,
  Label,
  Modal,
  Pagination,
  Select,
  Table,
} from "flowbite-react";
import { FaArrowsLeftRight } from "react-icons/fa6";
import axios from "../../config/axiosInstance";
import { useQuery, useQueryClient } from "react-query";
import { ADMIN, TICKETS } from "../../config/apiConfig";
import { IoMdSearch } from "react-icons/io";
import TableLoading from "../TableLoading";
import { Tooltip } from "react-tooltip";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { useForm } from "react-hook-form";
import EmptyTable from "./EmptyTable";

const AdminHelpCenterTable = ({ isActive = true }) => {
  const queryClient = useQueryClient();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const onPageChange = (page) => setCurrentPage(page);
  const [searchName, setSearchName] = useState("");
  const [nameParam, setNameParam] = useState("");
  const [isOpen, setOpenModal] = useState(false);
  const [isOpenView, setOpenModalView] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorSubmit, setErrorSubmit] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(0);
  const itemsPerPage = 20;

  const {
    isLoading: isLoadingTickets,
    error: errorListTickets,
    data: listTickets,
  } = useQuery(
    ["listTickets", currentPage],
    async () => {
      try {
        const { data } = await axios.get(
          `${ADMIN.GET_TICKETS}?page=${currentPage}&itemsPerPage=${itemsPerPage}`
        );
        setTotalPages(data.data.totalPages || 1);
        setTotalCount(data.data.totalCount || 0);
        return data.data.data;
      } catch (error) {
        console.error("Erro ao buscar dados:", error.message);
        throw new Error("Erro ao buscar dados.");
      }
    },
    { enabled: isActive }
  );

  const handleUpdateTicketStatus = async () => {
    setIsSubmitting(true);
    setErrorSubmit(false);
    try {
      await axios.put(`${TICKETS.CREATE}/${selectedTicket?.id}`, {
        status: selectedStatus,
      });
      setOpenModalView(false);
      queryClient.invalidateQueries("listTickets");
    } catch (error) {
      setErrorSubmit(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSearchName = (e) => {
    e.preventDefault();
    setNameParam(searchName);
  };

  const handleViewTicket = (ticket) => {
    setSelectedTicket(ticket);
    setOpenModalView(true);
  };

  return (
    <>
      <form
        className="flex gap-1 mt-5 w-full pl-3 pr-2 py-2 md:py-1 rounded-md shadow-sm bg-gray-300"
        onSubmit={handleSearchName}
      >
        <input
          type="text"
          placeholder="Busque por número do chamado..."
          className="border-0 py-1 text-sm mt-1 focus:outline-none focus:ring-0 focus:border-gray-300 px-0 w-full bg-gray-300 placeholder:text-gray-700"
          onChange={(e) => setSearchName(e.target.value)}
          value={searchName}
        />
        <Button
          size="sm"
          className="flex items-center bg-secondary w-20"
          type="submit"
        >
          <IoMdSearch />
        </Button>
      </form>
      <small
        className="gap-2 items-center mt-5 mb-1 flex md:hidden justify-center"
        style={{ fontSize: 10 }}
      >
        <span>Deslize para o lado para visualizar todas as informações</span>{" "}
        <FaArrowsLeftRight />
      </small>
      <div className="overflow-x-auto shadow-sm rounded-lg mt-0 md:mt-5">
        <Table striped>
          {listTickets?.length > 0 || isLoadingTickets ? (
            <Table.Head>
              <Table.HeadCell className="bg-gray-300 py-2 text-center">
                Nº Chamado
              </Table.HeadCell>
              <Table.HeadCell className="text-center bg-gray-300 py-2">
                Data
              </Table.HeadCell>
              <Table.HeadCell className="text-center bg-gray-300 py-2">
                Cliente
              </Table.HeadCell>
              <Table.HeadCell className="text-center bg-gray-300 py-2">
                Solicitante
              </Table.HeadCell>
              <Table.HeadCell className="text-center bg-gray-300 py-2">
                Título
              </Table.HeadCell>
              <Table.HeadCell className="text-center bg-gray-300 py-2">
                Status
              </Table.HeadCell>
              <Table.HeadCell className="text-center bg-gray-300 py-2">
                Ações
              </Table.HeadCell>
            </Table.Head>
          ) : (
            <></>
          )}

          <Table.Body className="divide-y">
            {!isLoadingTickets ? (
              <>
                {listTickets?.length > 0 ? (
                  <>
                    {listTickets?.map((support, index) => (
                      <Table.Row
                        key={index}
                        className="bg-white dark:border-gray-700 dark:bg-gray-800"
                      >
                        <Table.Cell className="font-medium text-gray-900 dark:text-white py-2 text-center">
                          #{support.id}
                        </Table.Cell>
                        <Table.Cell className="font-medium text-gray-900 dark:text-white py-2 text-center">
                          {moment(support.createdAt).format("DD/MM/yyyy") ||
                            "Não informado"}
                        </Table.Cell>
                        <Table.Cell className="font-medium text-gray-900 dark:text-white py-2 text-center">
                          {support?.User?.Company?.name ||
                            support?.User?.Company?.socialReason}
                        </Table.Cell>
                        <Table.Cell className="font-medium text-gray-900 dark:text-white py-2 text-center">
                          {support?.User?.name}
                        </Table.Cell>
                        <Table.Cell className="font-medium text-gray-900 dark:text-white py-2 text-center">
                          {support.title}
                        </Table.Cell>
                        <Table.Cell className="font-medium text-gray-900 dark:text-white py-2 text-center">
                          {support.status == 0 ? (
                            <Badge className="w-fit mx-auto" color="warning">
                              Pendente
                            </Badge>
                          ) : support.status == -1 ? (
                            <Badge className="w-fit mx-auto" color="failure">
                              Cancelado
                            </Badge>
                          ) : support.status == 2 ? (
                            <Badge className="w-fit mx-auto" color="success">
                              Concluído
                            </Badge>
                          ) : (
                            <Badge className="w-fit mx-auto" color="info">
                              Em andamento
                            </Badge>
                          )}
                        </Table.Cell>
                        <Table.Cell className="text-center py-2">
                          <div className="flex gap-2 justify-center">
                            <Tooltip
                              id="tooltip-view-details"
                              content="Visualizar detalhes"
                            />
                            <div className="flex gap-1 justify-center items-center flex-wrap">
                              <MdOutlineRemoveRedEye
                                data-tooltip-id="tooltip-view-details"
                                fontSize="16"
                                onClick={() => handleViewTicket(support)}
                                className="cursor-pointer text-gray-500"
                              />
                            </div>
                          </div>
                        </Table.Cell>
                      </Table.Row>
                    ))}
                  </>
                ) : (
                  <div>
                    <EmptyTable icon="help_center">
                      Nenhum chamado aberto
                    </EmptyTable>
                  </div>
                )}
              </>
            ) : (
              <TableLoading cols={5} />
            )}
          </Table.Body>
        </Table>
      </div>

      {totalCount > 0 && (
        <div className="mt-3 text-center text-sm text-gray-600">
          Exibindo {(currentPage - 1) * itemsPerPage + 1}–
          {Math.min(currentPage * itemsPerPage, totalCount)} de {totalCount}{" "}
          registros
        </div>
      )}

      {totalPages > 1 && (
        <div className="flex overflow-x-auto justify-center mt-3">
          <Pagination
            layout="pagination"
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={onPageChange}
            previousLabel=""
            nextLabel=""
            showIcons
          />
        </div>
      )}

      <Modal
        show={isOpenView}
        size="2xl"
        onClose={() => setOpenModalView(false)}
        popup
      >
        <Modal.Header />
        <Modal.Body>
          <div className="text-left">
            <div className="">
              {selectedTicket?.status == 0 ? (
                <Badge className="w-fit mx-auto" color="warning">
                  Pendente
                </Badge>
              ) : selectedTicket?.status == -1 ? (
                <Badge className="w-fit mx-auto" color="failure">
                  Cancelado
                </Badge>
              ) : selectedTicket?.status == 2 ? (
                <Badge className="w-fit mx-auto" color="success">
                  Concluído
                </Badge>
              ) : (
                <Badge className="w-fit mx-auto" color="info">
                  Em andamento
                </Badge>
              )}
              <h3 className="text-lg font-normal text-gray-500 dark:text-gray-400 mb-2 mt-2">
                Chamado: #{selectedTicket?.id}
              </h3>
              <div className="mb-2">Título: {selectedTicket?.title}</div>
              <div>Descrição: {selectedTicket?.description}</div>
              <div className="mt-4">
                <Label>Status do chamado</Label>
                <Select
                  onChange={(e) => setSelectedStatus(e.target.value)}
                  defaultValue={selectedTicket?.status}
                >
                  <option value={0}>Pendente</option>
                  <option value={1}>Em andamento</option>
                  <option value={2}>Concluído</option>
                  <option value={-1}>Cancelado</option>
                </Select>
                <Button
                  className="mx-auto mt-3"
                  onClick={handleUpdateTicketStatus}
                  isProcessing={isSubmitting}
                  disabled={isSubmitting}
                >
                  Salvar
                </Button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AdminHelpCenterTable;
